import React, { useState, useRef } from 'react'
import './index.scss'
import * as echarts from 'echarts/core';
import { GridComponent } from 'echarts/components';
import { LineChart, BarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { Bscroll } from '@/components/bscroll'
import NoEarn from '@/components/noearn'
import { toHourMinute } from '@/utils/utils'
import useDeepCompareEffect from 'use-deep-compare-effect';

const MEarnShow = (props) => {
  // 得到每月的详细收益信息
  let { monthIncomeList } = props
  //数据表数据
  let xMonth = []
  let monthData = []
  //变量拿到月份数据给数据表
  for (let i = 0, k = monthIncomeList.length; i < k; i++) {
    xMonth.push(monthIncomeList[i].calculateDate)
    monthData.push({
      value: monthIncomeList[i].amount,
      stayt: monthIncomeList[i].onlineTime
    })
  }
  const echarsDom = useRef(null);
  let [options, setOptions] = useState({});
  let [lineW, setLineW] = useState(4);
  let [symbolSize, setSymbolSize] = useState(10);
  let [fontSize, setFontSize] = useState(18);
  let [xSize, setXSize] = useState(4);
  echarts.use(
    [GridComponent, LineChart, BarChart, CanvasRenderer]
  );
  let data = {
    xAxis: {
      type: 'category',
      boundaryGap: false,

      axisTick: {
        show: true,
        inside: true,
        length: 10
      },
      nameGap: 10,
      axisLabel: {
        fontSize: fontSize,
        color: "#888",
        distance: 10,
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: "#f1f1f1",
          width: xSize
        }
      },
      splitLine: {
        show: true
      },
      minorSplitLine: {
        show: true
      },
      offset: 1,
      data: xMonth,
    },
    yAxis: {
      type: 'value',
      show: false,
    },
    series: [{
      data: monthData,
      type: 'line',
      smooth: true,
      symbolSize: symbolSize,
      label: {
        show: true,
        position: 'top',
        color: '#666',
        fontSize: fontSize,
        formatter: function (params) {
          let str = params.value / 100 + "元\n" + toHourMinute(params.data.stayt) + "小时"
          return str
        },
      },
      // labelLine: {
      //   show: true
      // },
      lineStyle: {
        width: lineW,
        shadowColor: React.colorConfig ? React.colorConfig.mainColor : '#FFA43C',
        shadowBlur: 10,
        shadowOffsetY: 3
      },
      animation: false
    }],
    color: React.colorConfig ? React.colorConfig.mainColor : '#FFA43C',
  };

  useDeepCompareEffect(() => {

    if (monthIncomeList.length > 0) {
      new Promise((res) => {
        let dataDpr = document.querySelector('html').getAttribute('data-dpr');
        if (dataDpr < 2) {
          setLineW(2);
          setSymbolSize(5)
          setFontSize(8)
          setXSize(2)
        }
        res()
      })
        .then(() => {
          // 
          setOptions(() => (
            options = data
          ));
          var myChart = echarts.init(echarsDom.current);
          options && myChart.setOption(options);
        })
    }
  }, [xSize, lineW, symbolSize, fontSize, xMonth, monthData])
  return (
    <div className="m-earn__box">
      {
        monthIncomeList.length <= 0 ? <NoEarn /> :
          <Bscroll scrollX={true} scrollY={false} bounce={{ left: false, right: false }} momentum={false} startX={monthIncomeList.length === 1 ? '-50%' : ''}>
            <div className="echarts__show" style={monthIncomeList.length === 1 ? { left: '100%', transform: 'translateX(-63%)' } : {}} ref={echarsDom}></div>
          </Bscroll>
      }

    </div>
  )
}
export default MEarnShow
